import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Home/Footer";
import Social from "../Components/Home/Social";
import RmCarousel from "../Components/Home/Carousel";
import Message from "../Components/Home/Message";
import Category from "../Components/Home/Category";
import Listicle from "../Components/Home/Listicle";
import Subscriber from "../Components/Home/Subscribers";
import Benefit from "../Components/Home/Benefit";

const Delhi = () => {
  return (
    <div>
      <RmCarousel />
      <Category />
      <Listicle />
      <Benefit />
      <Subscriber />
    </div>
  );
};

export default Delhi;
